<template>
  <main class="c-app-content">
    <div class="c-app-title">
      <div>
        <h1>
          <img class="c-app-title__icon" src="../assets/images/icons/icon24-opportunities-primary.svg" :alt="$t('internalContacts')"> {{ $t('internalContacts') }}
        </h1>
      </div>
      <ul class="c-app-breadcrumb breadcrumb">
        <li class="breadcrumb-item"><router-link to="/">{{ $t('callio') }}</router-link></li>
        <li class="breadcrumb-item"><router-link to="/contact">{{ $t('contacts') }}</router-link></li>
        <li class="breadcrumb-item active">Danh sách bác sỹ</li>
      </ul>
    </div>
    <div class="col" v-if="firstLoading">
      <skeleton-loading>
        <row>
          <square-skeleton :boxProperties="{bottom: '10px', height: '30px'}"></square-skeleton>
        </row>
        <row>
          <square-skeleton :boxProperties="{bottom: '10px', height: '200px'}"></square-skeleton>
        </row>
      </skeleton-loading>
    </div>
    <div class="tile" v-else>
      <div class="c-action">
        <div class="row">
          <div class="col-lg-3 c-action__left">
                        <span class="c-action__count">
                            {{ $t('listSummary', [firstItemOfPage, lastItemOfPage, itemCount, $t('users')]) }}
                        </span>
          </div>
          <div class="col-lg-9 c-action__right">
            <div class="c-config-content__search-right">
              <div class="c-search-all">
                <div class="c-search-all__inner"><i class="c-search-all__icon icon16-search-gadient"></i>
                  <b-form-input class="form-control" v-model="filterFormModel.keyword" :placeholder="$t('keyword')" @keyup="search">
                  </b-form-input>
                </div>
              </div>
            </div>
            <user-group-select :model="filterFormModel" attribute="group" @change="search" is-filter></user-group-select>
            <dropdown :model="filterFormModel" attribute="role" :label="$t('role')" :right-menu="true" type="bordered" :options="roles" @change="search"></dropdown>
            <dropdown :model="filterFormModel" attribute="sort" :label="$t('sortBy')" :right-menu="true" type="bordered" icon="icon12-sort-descending-primary" :options="[
                            {value:null,text:$t('createTimeDESC')},
                            {value:'createTimeASC',text:$t('createTimeASC')},
                            {value:'nameASC',text:$t('nameASC')},
                            {value:'nameDESC',text:$t('nameDESC')},
                        ]" @change="search"></dropdown>
            <dropdown :model="filterFormModel" attribute="status" :label="$t('status')" :right-menu="true" type="bordered" icon="fa fa-list" :options="[
                            {value: null, text: 'Tất cả'},
                            {value: '2', text: 'Đang trực tuyến'},
                            {value: '0', text: 'Đang hoạt động'},
                            {value: '1', text: 'Tạm dừng'},
                        ]" @change="search"></dropdown>
            <dropdown :model="filterFormModel" attribute="pairStatus" label="Trạng thái ghép cặp" :right-menu="true" type="bordered" icon="fa fa-list" :options="[
                            {value: null, text: 'Tất cả'},
                            {value: '0', text:'Chưa ghép cặp'},
                            {value: '1', text:'Đã ghép cặp'},
                        ]" @change="search"></dropdown>
            <button class="btn btn-sm btn-primary" @click="search"><i class="fa fa-refresh mr-0"></i></button>
          </div>
        </div>
        <div class="row" v-if="$store.state.user.permissions.find(p => p.startsWith('userManage'))">
          <div class="col-lg-12 c-action__right">
            <b-button class="btn btn-success btn-sm" @click="create" data-toggle="modal" data-target="#partner-addnew">
              <i class="icon12-add-white icon-left"></i>Thêm mới BS | NVYT
            </b-button>
            <import-user></import-user>
            <export-user :filter="filterFormModel" :total-count="itemCount" v-if="items && items.length"></export-user>
          </div>
        </div>
      </div>
      <div v-if="listLoading" class="text-center text-primary">
        <b-spinner></b-spinner>
      </div>
      <div v-if="!listLoading && !itemCount" class="text-center text-danger">
        {{ $t('emptyList') }}
      </div>
      <div v-if="!listLoading && itemCount" class="c-template-table table-responsive">
        <table class="table table-bordered table-hover">
          <thead>
          <tr>
            <th>Thông tin tài khoản</th>
            <th>{{ $t('group') }}</th>
            <th>{{ $t('role') }}</th>
            <th>Ghép cặp</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in items" :key="item._id">
            <td>
              <p>Họ tên: <b>{{ item.name }}</b></p>
              <p>Email: <b>{{ item.email }}</b></p>
              <p v-if="item.phone">SĐT: <b>{{ item.phone }}</b></p>
              <p>Số nhánh:
                <a href="javascript:;" @click="makeCall(item.ext)" v-b-tooltip="$t('clickToCallLocal')">
                  <i class="icon12-phone-volume-primary"></i>&nbsp;<b>{{ item.ext }}</b>
                </a>
              </p>
              <p>Lần online cuối:
                <b v-if="item.lastOnlineTime">{{item.lastOnlineTime | moment('DD/MM/YY HH:mm')}}</b>
                <b v-else>Chưa online</b>
              </p>
              <p>
                <span v-if="(Date.now()-item.lastOnlineTime)<=60*15*1000" class="badge badge-info">
                  <a href="javascript:;" @click="makeCall(item.ext)" v-b-tooltip="$t('clickToCallLocal')">
                    {{$t('online')}}
                  </a>
                </span>
                <span v-else class="badge badge-secondary">{{$t('offline')}}</span>&nbsp;
                <span v-if="item.active" class="badge badge-success">Hoạt động</span>
                <span v-else class="badge badge-danger">Tạm khoá</span>
                <a href="javascripts:;" @click="changeStatus(item._id, item.active)"  v-if="checkUpdatePermission(item) && !lockLoading">
                   | {{item.active ? 'Khoá' : 'Mở khoá'}}</a>
                <b-spinner v-if="lockLoading" small></b-spinner>
              </p>
            </td>
            <td>
              <p v-if="item.group">{{ item.group.name }}</p>
              <p v-else>{{ $t('default') }}</p>
            </td>
            <td>
              <p>{{ getRoleName(item.role) }}</p>
            </td>
            <td>
              <template v-if="item.nhomNVYT">
                <template v-if="['bac-sy-pho-nhom','bac-sy'].includes(item.role)">
                  <template v-if="item.nhomNVYT.followUsers && item.nhomNVYT.followUsers.length">
                    <p>Tổng số: <b>{{item.nhomNVYT.followUsers.length}}</b> TNV:</p>
                    <p v-for="(u, index) of item.nhomNVYT.followUsers" :key="u._id">
                      <b>{{index + 1}}</b> |
                      <span>Họ tên: <b>{{u.name}}</b></span> |
                      <span>Email: <b>{{u.email}}</b></span> |
                      <span>SĐT: <b>{{u.phone ? u.phone : 'Chưa cập nhật'}}</b></span> |
                      <span>Số nhánh: <a href="javascript:;" @click="makeCall(u.ext)" v-b-tooltip="$t('clickToCallLocal')">
                        <i class="icon12-phone-volume-primary"></i>&nbsp;<b>{{u.ext}}</b></a>
                      </span> |
                      <span>Lần online cuối:
                        <b v-if="u.lastOnlineTime">{{u.lastOnlineTime | moment('DD/MM/YY HH:mm')}}</b>
                        <b v-else>Chưa online</b>
                      </span>
                    </p>
                  </template>
                  <span v-else>Đã có cặp nhưng trong cặp chưa có TNV nào</span>
                  <template v-if="checkUpdatePermission(item)">
                    <hr>
                    <a href="javascript:;" @click="updateNhomNVYT(item.nhomNVYT._id)">Cập nhật ghép cặp</a>
                  </template>
                </template>
                <span v-if="item.role === 'nvyt'">
                  Bác sỹ: <b>{{item.nhomNVYT.doctorUser.name}}</b>
                  | Email: <b>{{item.nhomNVYT.doctorUser.email}}</b>
                  | Số nhánh: <b><i class="icon12-phone-volume-primary"></i>&nbsp;<a href="javascript:;" @click="makeCall(item.nhomNVYT.doctorUser.ext)" v-b-tooltip="$t('clickToCallLocal')">{{item.nhomNVYT.doctorUser.ext}}</a></b>
                  | SĐT: <b>{{item.nhomNVYT.doctorUser.phone ? item.nhomNVYT.doctorUser.phone : 'Chưa cập nhật'}}</b>
                </span>
              </template>
              <p v-else>
                Chưa ghép cặp
                <span v-if="['bac-sy-pho-nhom', 'bac-sy'].includes(item.role) && checkUpdatePermission(item) && item.active">
                  | <a href="javascript:;" @click="createNhomNVYT(item)">Tạo ghép cặp mới</a>
                </span>
                <span v-if="item.role === 'nvyt' && checkUpdatePermission(item) && item.active">
                  | <a href="javascript:;" @click="pairRandomly(item._id)" v-if="!pairLoading">Ghép cặp ngẫu nhiên</a>
                  <b-spinner small v-else></b-spinner>
                </span>
              </p>
            </td>
            <td>
              <button class="btn btn-sm btn-outline-gray" @click="update(item._id)" :disabled="updateLoading" v-if="checkUpdatePermission(item)">
                <b-spinner v-if="updateLoading" small></b-spinner>
                <i v-else class="fa fa-edit"></i> Sửa thông tin</button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="c-paging" v-if="itemCount > filterFormModel.pageSize">
        <b-pagination size="sm" class="pagination pagination-sm justify-content-center"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
      <b-modal v-model="showForm" :title="formTitle + $t('userFormTitle')" @ok="save" no-close-on-backdrop no-enforce-focus>
          <form autocomplete="off">
            <div class="row">
              <div class="col-md">
                <form-input :label="$t('name')" :model="formModel" attribute="name" :errors="formErrors"
                            :placeholder="$t('userNamePlaceholder')">
                </form-input>
                <form-input :label="$t('email')" :model="formModel" attribute="email" :errors="formErrors"
                            type="email" :placeholder="$t('userEmailPlaceholder')"></form-input>
                <form-input :label="$t('phone')" :model="formModel" attribute="phone" :errors="formErrors"
                            :placeholder="$t('userPhonePlaceholder')">
                </form-input>
                <form-textarea :label="$t('desc')" :model="formModel" attribute="desc" :errors="formErrors"
                               :placeholder="$t('userDescPlaceholder')">
                </form-textarea>
              </div>
            </div>
            <div class="row">
              <div class="col-md">
                <user-group-select-form :label="$t('group')" :model="formModel" :errors="formErrors"></user-group-select-form>
              </div>
              <div class="col-md">
                <form-select :label="$t('role')" :model="formModel" attribute="role" :errors="formErrors" :options="roles"></form-select>
              </div>
            </div>
          </form>
          <template v-slot:modal-footer>
            <b-button variant="secondary" class="float-right" @click="showForm = false">{{ $t('cancel') }}
            </b-button>
            <b-button :disabled="saveLoading" variant="primary" class="float-right" @click="save">
              <b-spinner v-if="saveLoading" small></b-spinner>
              {{ $t('save') }}
            </b-button>
          </template>
        </b-modal>
      <nhom-n-v-y-t-modal ref="nhomNVYT"></nhom-n-v-y-t-modal>
    </div>
  </main>
</template>

<script>
import list from '../mixins/List';
import crud from '../mixins/CRUD';
import _ from 'lodash';
import Dropdown from "../components/Dropdown";
import UserGroupSelect from "@/components/UserGroupSelect";
import UserGroupSelectForm from "@/components/UserGroupSelectForm";
import ImportUser from "@/views/ImportUser";
import NhomNVYTModal from "@/views/nhom-nvyt/NhomNVYTModal";
import ExportUser from "@/views/ExportUser";

export default {
  components: {ExportUser, NhomNVYTModal, UserGroupSelect, UserGroupSelectForm, Dropdown, ImportUser},
  mixins: [list, crud],
  data: function () {
    return {
      service: "/user-bac-sy",
      autoLoad: true,
      reloadBus: 'reloadInternalContact',
      defaultFilterFormModel: {
        status: null,
        pairStatus: null,
        keyword: '',
        group: ['bac-sy-truong-nhom', 'bac-sy-pho-nhom', 'bac-sy', 'nvyt'].includes(this.$store.state.user.role) ? this.$store.state.user.group : null,
        sort: null,
        role: null
      },
      roles: [
        {value: null, text: this.$t('chooseRole')},
        {value: 'bac-sy-truong-nhom', text: 'Bác sỹ trưởng nhóm'},
        {value: 'bac-sy-pho-nhom', text: 'Bác sỹ phó nhóm'},
        {value: 'bac-sy', text: 'Bác sỹ'},
        {value: 'nvyt', text: 'TNV'},
      ],
      lockLoading: false,
      pairLoading: false
    };
  },
  methods: {
    makeCall(number) {
      this.$bus.$emit('makeCall', number);
    },
    search: _.debounce(function () {
      this.filterFormModel.page = 1;
      this.load();
    }, 200),
    getRoleName(key) {
      if (['owner', 'supervisor', 'agent'].includes(key)) {
        return this.$t(key);
      }
      let role = this.$store.state.roles.find(r => r.key === key);
      if (role && role.name) {
        return role.name
      }
      return key
    },
    checkUpdatePermission(item) {
      if (this.$store.state.user.permissions.includes('userManageAll')) {
        return true
      }
      if (this.$store.state.user.permissions.includes('userManageGroup')){
        if (!item.group && this.$store.state.user.roleGroups.includes('default')) {
          return true
        }
        if (item.group && this.$store.state.user.roleGroups.includes(item.group._id)) {
          return true
        }
      }
      return false
    },
    changeStatus(id, status) {
      this.$swal({
        icon: 'info',
        text: status ? 'Bạn có chắc muốn khoá tài khoản này?' : 'Bạn có chắc muốn kích hoạt lại tài khoản này?',
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          this.lockLoading = true;
          this.$service.post('/user-bac-sy/change-status/' + id).then(response => {
            if (response && response.data) {
              this.$swal({
                icon: 'success',
                text: status ? 'Khoá thành công' : 'Mở khoá thành công!',
                toast: true,
                timer: 5000,
                position: 'top-end'
              });
              this.load();
            } else {
              this.$swal({
                icon: 'error',
                text: 'Có lỗi'
              })
            }
          }).catch(error => {
            if (error.response.data.message) {
              this.$swal({
                text: error.response.data.message,
                icon: 'error'
              });
            }
          }).finally(() => {
            this.lockLoading = false;
          })
        }
      })
    },
    updateNhomNVYT(id) {
      this.$refs.nhomNVYT.update(id)
    },
    createNhomNVYT(item) {
      this.$refs.nhomNVYT.createNhomNVYT(item.group._id, item._id);
    },
    pairRandomly(id) {
      this.$swal({
        icon: 'info',
        text: 'Bạn có chắc muốn ghép TNV này vào một cặp đã có sẵn trong nhóm một cách ngẫu nhiên?',
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          this.pairLoading = true;
          this.$service.post('/nhom-nvyt/pair/' + id).then(response => {
            if (response && response.data) {
              this.$swal({
                icon: 'success',
                text: 'Ghép cặp ngẫu nhiên thành công!',
                toast: true,
                timer: 5000,
                position: 'top-end'
              })
              this.load();
            } else {
              this.$swal({
                title: this.$t('error'),
                text: 'Có lỗi trong việc ghép cặp ngẫu nhiên',
                icon: 'error',
              });
            }
          }).catch(error => {
            if (error.response.data.message) {
              this.$swal({
                text: error.response.data.message,
                icon: 'error'
              });
            }
          }).finally(() => {
            this.pairLoading = false;
          })
        }
      })
    }
  },
  mounted() {
  }
};
</script>